const location = window.location.href;

// Production URLs (existing)
const apiProdURL = 'goals.arootah.com';
const userProdURL = 'auth.arootah.com';
const hatProdURL = 'app.arootah.com';
const ppProdURL = 'apps.arootah.com';

// Staging URLs (existing)
const apiStagingURL = 'goals-staging.arootah.com';
const userStagingURL = 'auth-staging.arootah.com';
const hatStagingURL = 'app-staging.arootah.com';
const ppStagingURL = 'apps-staging.arootah.com';

// DigitalOcean Production URLs
const apiDigitalOceanProdURL = 'arootah-goal-manager-prod-g2l9r.ondigitalocean.app';
const userDigitalOceanProdURL = 'arootah-user-service-production-6y4ss.ondigitalocean.app';
const hatDigitalOceanProdURL = 'arootah-habit-manager-production-re22a.ondigitalocean.app';
const ppDigitalOceanProdURL = 'arootah-project-manager-prod-l9c4x.ondigitalocean.app';

// DigitalOcean Staging URLs
const apiDigitalOceanStagingURL = 'arootah-goal-manager-staging-ggg97.ondigitalocean.app';
const userDigitalOceanStagingURL = 'arootah-user-service-staging-ev7t2.ondigitalocean.app';
const hatDigitalOceanStagingURL = 'arootah-habit-manager-staging-itze9.ondigitalocean.app';
const ppDigitalOceanStagingURL = 'arootah-project-manager-staging-5zjm3.ondigitalocean.app';

// Initialize default URLs
let apiURL = apiProdURL;
let userURL = userProdURL;
let hatURL = hatProdURL;
let ppURL = ppProdURL;

// Helper function to detect environment type
const detectEnvironment = () => {
  const isDigitalOcean = location.includes('ondigitalocean.app');
  
  if (isDigitalOcean) {
    // Check if it's staging or production DigitalOcean
    const isDigitalOceanStaging = location.includes(apiDigitalOceanStagingURL);
    
    if (isDigitalOceanStaging) {
      return 'digitalocean-staging';
    } else {
      return 'digitalocean-production';
    }
  }
  
  // Check traditional staging URLs
  if (location.includes(apiStagingURL)) {
    return 'staging';
  }
  
  // Check development environment
  if (process.env.NODE_ENV === 'development') {
    return 'development';
  }
  
  // Default to production
  return 'production';
};

// Set URLs based on detected environment
const environment = detectEnvironment();

switch (environment) {
  case 'digitalocean-staging':
    apiURL = apiDigitalOceanStagingURL;
    userURL = userDigitalOceanStagingURL;
    hatURL = hatDigitalOceanStagingURL;
    ppURL = ppDigitalOceanStagingURL;
    break;
    
  case 'digitalocean-production':
    apiURL = apiDigitalOceanProdURL;
    userURL = userDigitalOceanProdURL;
    hatURL = hatDigitalOceanProdURL;
    ppURL = ppDigitalOceanProdURL;
    break;
    
  case 'staging':
  case 'development':
    apiURL = apiStagingURL;
    userURL = userStagingURL;
    hatURL = hatStagingURL;
    ppURL = ppStagingURL;
    break;

  case 'production':
  default:
    apiURL = apiProdURL;
    userURL = userProdURL;
    hatURL = hatProdURL;
    ppURL = ppProdURL;
    break;
}

// Environment status logging
const getEnvironmentIcon = () => {
  switch (environment) {
    case 'production':
      return '🟢';
    case 'digitalocean-production':
      return '🔵';
    case 'staging':
    case 'digitalocean-staging':
      return '🟡';
    case 'development':
      return '🟠';
    default:
      return '⚪';
  }
};

console.log(`${getEnvironmentIcon()} Environment: ${environment}`);
console.log(`${getEnvironmentIcon()} API:`, apiURL);
console.log(`${getEnvironmentIcon()} User Service:`, userURL);
console.log(`${getEnvironmentIcon()} HAT/Habit Manager:`, hatURL);
console.log(`${getEnvironmentIcon()} Project Planner:`, ppURL);

// API URL exports (for backend calls)
export const ROOT_API_URL = `https://${apiURL}/api/v1/`;
export const WEBSOCKET_URL = `wss://${apiURL}/ws/chat/`;
export const AUTH_API_URL = `https://${userURL}/api/v1/`;
export const HAT_API_URL = `https://${hatURL}/api/v1/`;
export const PP_API_URL = `https://${ppURL}/api/v1/`;

// App URL exports (for navigation)
export const GOAL_MANAGER_APP_URL = `https://${apiURL}`;
export const USER_SERVICE_APP_URL = `https://${userURL}`;
export const HAT_APP_URL = `https://${hatURL}`;
export const PP_APP_URL = `https://${ppURL}`;

// Backward compatibility aliases
export const HABIT_API_URL = HAT_API_URL;
export const HABIT_MANAGER_APP_URL = HAT_APP_URL;
export const PROJECT_PLANNER_API_URL = PP_API_URL;
export const PROJECT_PLANNER_APP_URL = PP_APP_URL;

// Environment flags (backward compatibility)
export const isStaging = environment === 'staging' || environment === 'digitalocean-staging';
export const isProduction = environment === 'production' || environment === 'digitalocean-production';
export const isDevelopment = environment === 'development';
export const isDigitalOcean = environment.includes('digitalocean');

// Environment information export
export const environmentInfo = {
  type: environment,
  isDigitalOcean,
  isStaging,
  isProduction,
  isDevelopment,
  urls: {
    api: apiURL,
    user: userURL,
    hat: hatURL,
    pp: ppURL
  }
};
